import { LocalStorage } from 'shared/utils/storage'

// Mocked credentials for provider that already holds an API token.
// `authorize` verifies it against /me instead of logging in with a password. 
// Not a real account.
export const EXTERNAL_TOKEN_LOGIN_EMAIL = 'external@fake.com'
export const EXTERNAL_TOKEN_LOGIN_PASSWORD_PLACEHOLDER = '123'

// Guest cart id survives login so the cart can be merged afterwards.
export const UNAUTHENTICATED_CART_ID_LOCAL_STORAGE_KEY = 'unauthenticated_cart_id'

export const LOGIN_REDIRECT_LOCAL_STORAGE_KEY = 'login-redirect'

export const loginRedirectLocalStorage = new LocalStorage(
  LOGIN_REDIRECT_LOCAL_STORAGE_KEY
)
